import { Col, Row } from "antd";
import { useNavigate } from "react-router-dom";
import { toLogout } from "../utils/APIs";

export const Header = ({ step, updateStep }) => {
  const navigate = useNavigate();

  const logout = async () => {
    toLogout().then((res) => {
      navigate("/login");
    });
  };

  const toGoBack = () => {
    if (step && step != 1) {
      updateStep();
    } else {
      navigate(-1);
    }
  };
  return (
    <>
      <Row style={{ paddingRight: "2vh", paddingBottom: "2vh" }}>
        <Col span="12" style={{ marginTop: "1vh" }}>
          <img
            src="/images/icons/monitoringText.png"
            className="roi--cursor"
            onClick={() => navigate("/admin")}
            style={{ width: "300px", marginLeft: "2vh" }}
          />
        </Col>
        <Col span="12" style={{ marginTop: "1vh", textAlign: "right" }}>
          <img
            style={{ width: "14px" }}
            src="/images/icons/back.svg"
            onClick={() => toGoBack()}
            className="roi--cursor"
          />
          <img
            src="/images/icons/home.svg"
            style={{ marginLeft: "28px", width: "28px" }}
            className="roi--cursor"
            onClick={() => navigate("/admin")}
          />
          <img
            src="/images/icons/logout.svg"
            style={{ marginLeft: "60px", width: "28px" }}
            className="roi--cursor"
            onClick={() => logout()}
          />
        </Col>
      </Row>
    </>
  );
};
